import { render, staticRenderFns } from "./ReadAboutTile.vue?vue&type=template&id=6a5132dc&scoped=true"
import script from "./ReadAboutTile.vue?vue&type=script&lang=js"
export * from "./ReadAboutTile.vue?vue&type=script&lang=js"
import style0 from "./ReadAboutTile.vue?vue&type=style&index=0&id=6a5132dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5132dc",
  null
  
)

export default component.exports